module.exports = __webpack_public_path__ + "static/airport-4-c9415162fe79c0423fecc9cee29f8ad8.jpg";